import anime from 'animejs/lib/anime.es.js';
import 'intersection-observer';
import animationsConfigs from '../configs/animationTargets.json';

class SvgAnimate {
  constructor(config = {}) {
    const defaultConfig = {
      targetIds: []
    };
    this.animations = [];
    this.config = Object.assign(defaultConfig, config);
    this.watch();
  }

  watch() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          const item = this.config.targetIds.filter((t) => {
            return t.id === entry.target.id
          });

          if (this.animations && this.animations[entry.target.id]) {
            this.animations[entry.target.id].play();
          } else {
            this.animateTargetSvg(item[0]);
          }

          //observer.unobserve(entry.target);
        } else {
          if (this.animations && this.animations[entry.target.id]) {
            this.animations[entry.target.id].pause();
          }
        }
      });
    });

    const targets = document.querySelectorAll('.anime');
    targets.forEach(animation => {
      observer.observe(animation);
    });
  }

  animateTargetSvg(el) {
    const targetId = document.getElementById(el.pathId);
    let animeConfigs = [];

    if (!el.paths || el.paths.length === 0) {
      return;
    }

    el.paths.map(path => {
      animeConfigs.push({
        value: path
      })
    });

    this.animations[el.id] = anime({
      targets: targetId,
      d: animeConfigs,
      //translateX: window.innerWidth*0.8,
      //translateY: anime.path(targetId.parentNode.getElementsByTagName("path")[0]),
      elasticity: 100,
      autoplay: true,
      easing: el.animationType,
      //easing: 'cubicBezier(.5, .05, .1, .3)',
      duration: el.duration,
      direction: "alternate",
      loop: true
    });
  }
}


let isInit = false;
animationsConfigs.targetIds.forEach(config => {
  if(!$(config.appendTo).find("svg").length) {
  const animeContainer = $('<div />', {
    id: config.id,
    class: 'anime'
  }).append(config.svg)


    $(config.appendTo).append(animeContainer)
  }

  isInit = true;
})

new SvgAnimate(animationsConfigs);
